module.exports = __webpack_public_path__ + "static/media/cuencalogo-white.e8c3909a.png";